import React from "react";
import { Component } from "react";
import { Link } from "react-router-dom";

class Breadcrumb extends Component {
  render() {
    return (
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb pl-0">
          <li className="breadcrumb-item">
            <Link to="/dashboard-report">
              <i className="material-icons">home</i> Home
            </Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/grn">Goods Received Note(GRN)</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Edit Goods Received Note(GRN)  
          </li>
        </ol>
      </nav>
    );
  }
}

export default Breadcrumb;
